import usePersistentStore from '@gui/store/persistent/persistentStore';
import type { BlockParameters } from '@visualizer/types';

export function usePipelineBlockParams<T extends BlockParameters>(blockId: string): T | undefined {
    return usePersistentStore((state) => {
        const activeLayerId = state.layers.activeLayerID;
        if (!activeLayerId) {
            return undefined;
        }
        const layer = state.layers.layerStates[activeLayerId];
        const block = layer?.pipeline.blocks.find((entry) => entry.id === blockId);
        return (block?.params as T) ?? undefined;
    });
}
